
<component
  :is="tagCompute"
  :to="to"
  :href="href"
  :target="target"
  class="breadcrumb-container inline-block mt-16"
  @click="clickEmitter"
>
  <div v-if="header" class="flex flex-row items-center breadcrumb">
    <ArrowHead style="transform: scaleX(-1)" class="mr-8" />
    <span>{{ header }}</span>
  </div>
</component>
